// Single source of truth for "are we running inside the Capacitor native shell?".
// On the web window.Capacitor is undefined, so this is always false.
export function isNativeApp(): boolean {
  const cap = (window as any).Capacitor;
  return !!cap?.isNativePlatform?.();
}
